import { T_PRICING_PAGE_CONSTANTS } from './TYPES'

const FR_PRICING_PAGE_CONSTANTS: T_PRICING_PAGE_CONSTANTS = {
  TITLE: "Plans d'abonnement pour enfants",
  DESCRIPTION: [
    {
      label: 'Forfaits tout compris : Parfaits pour tous les besoins !'
    },
    {
      newLine: true,
      label:
        "Les adultes peuvent utiliser la plateforme gratuitement, tandis que les enfants bénéficient d'une"
    },
    {
      label: "période d'essai gratuite de 15 jours !",
      color: true
    }
  ]
}

export default FR_PRICING_PAGE_CONSTANTS
